import { Navigate, Route, Routes } from "react-router-dom";
import { useDarknetIdentity } from "../contexts/IdentityContext";

import AdminPage from "../pages/Admin";
import HomePage from "../pages/Home";
import ProfilePage from "../pages/Profile";
import GameLibrary from "../pages/Library";
import GameInfo from "../pages/GameInfo";
import OpenGames from "../pages/OpenGames";
import PlayGame from "../pages/PlayGame";
import RewardsPage from "../pages/Rewards";
import LeaderboardsPage from "../pages/Leaderboards";
import Test from "../pages/MetaplexTest";

const AppRouter = () => {
    const { authenticated, identity } = useDarknetIdentity();

    return (
        <Routes>
            <Route path='/' element={<HomePage />} />
            <Route path='/profile' element={<ProfilePage />} />
            <Route path='/profile/:profileAddress' element={<ProfilePage />} />
            <Route path='/games' element={<GameLibrary />} />
            <Route path='/game/:gameId' element={<GameInfo />} />
            <Route path='/game/:gameId/play' element={<PlayGame />} />
            <Route path='/pvp' element={<OpenGames />} />
            <Route path='/pong/:instanceId' element={<PlayGame />} />
            <Route path='/rewards' element={<RewardsPage />} />
            <Route path='/leaderboards' element={<LeaderboardsPage />} />
            <Route path='/test' element={<Test />} />

            {authenticated && identity.account.name === "Shadow386" && (
                <Route path='/admin' element={<AdminPage />} />
            )}

            <Route path='*' element={<Navigate to='/' />} />
        </Routes>
    );
}

export default AppRouter;